import useDate from "../../hooks/useDate"
import useName from "../../hooks/useName"
import { Badge } from "../ui/badge"

interface Props {
  coach?: boolean
}

const Greeting: React.FC<Props> = ({ coach }) => {
  const { timeOfDay } = useDate()
  const { username } = useName()

  return (
    <>
      <div
        className="w-full max-w-screen-xl px-[20px] mx-auto mb-[24px]"
        data-cy="coach-greeting"
      >
        <div className="flex items-center gap-[12px]">
          <h4 className="text-black text-[18px] font-bold capitalize">
            Good {timeOfDay}, {username || "Guest"}
          </h4>

          {coach && <Badge variant="outline">Coach</Badge>}
        </div>
      </div>
    </>
  )
}

export default Greeting
